import * as React from "react";
const ChevronLeftLargeSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M-7.14 11.145a.5.5 0 010 .707l-3.646 3.648 3.646 3.647a.5.5 0 11-.707.707L-12.2 15.5l4.353-4.355a.5.5 0 01.707 0zM11.987 13.93a.75.75 0 11-1.06 1.06L5.438 9.497l5.488-5.492a.75.75 0 011.06 1.061L7.561 9.498l4.426 4.431z" }));
ChevronLeftLargeSmall.displayName = "ChevronLeftLargeSmall";
var ChevronLeftLargeSmall_default = ChevronLeftLargeSmall;
export {
  ChevronLeftLargeSmall_default as default
};
